<template>
  <div class="box-item top">
    <z-collapse :title="$t('rongzisqs.nowFinancingInfo')">
      <!--当前欠款-->
      <p class="cur-lending">{{$t('rongzisqs.arrears')}}：{{dataObj.currentOverDraftUnit}} {{dataObj.currentOverDraft | formatNum}}</p>
    </z-collapse>
<!--    当前融资情况 -->

    <z-collapse :title="$t('rongzisqs.financeAppRecord')">
      <el-table :data="financeList.slice((financePage.pageNo-1)*pageSize, financePage.pageNo*pageSize)" class="dtl-tb" :class="financePage.total>5? '':'pb-20'">
        <el-table-column prop="flowNumber" align="center" :label="$t('rongzisqs.financeFlowNumber')" width="170"></el-table-column>
        <el-table-column align="center" :label="$t('rongzisqs.financeAppCreateTime')" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.applyTime | dateConvert}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="financingEndDate" align="center" :label="$t('rongzisqs.financeStEnTime')" width="350">
          <template slot-scope="scope">
            <span v-if="scope.row.estimateStartDate">{{ scope.row.estimateStartDate | dateConvertDoit}}-{{ scope.row.estimateEndDate | dateConvertDoit}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('rongzisqs.financeMoney')">
          <template slot-scope="scope">
            <span>{{ scope.row.applyMoneyType}} {{ scope.row.applyMoney | formatNum}}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="page-theme text-center pb_25" background layout="prev, pager, next"
                     :total="financePage.total" :page-size="pageSize"
                     :current-page.sync="financePage.pageNo" v-show="financePage.total>5">
      </el-pagination>
    </z-collapse>
    <!--    最近10笔融资申请-->

    <z-collapse :title="$t('rongzisqs.lastOrder')">
      <el-table :data="orderList.slice((orderPage.pageNo-1)*pageSize, orderPage.pageNo*pageSize)" class="dtl-tb">
<!--        :class="orderPage.total>5? '':'pb-20'"-->
        <el-table-column prop="orderCode" align="center" :label="$t('financingApplication.orderNumber')" width="175"></el-table-column>
        <el-table-column prop="productName" align="center" :label="$t('rongzisqs.productName')" width="170"></el-table-column>
        <el-table-column align="center" :label="$t('financingApplication.price')" width>
          <template slot-scope="scope">
            <span>{{ scope.row.referencePrice | formatNum}} {{scope.row.referencePriceUnitName}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('financingApplication.num')" width>
          <template slot-scope="scope">
            <span>{{ scope.row.quantity | formatNum}} {{scope.row.quantityUnitName}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" :label="$t('poolOfMoney_page.moneyNum')" width>
          <template slot-scope="scope">
            <span>{{scope.row.contractPriceUnitName}} {{ scope.row.contractPrice | formatNum}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="priceType" align="center" :label="$t('loan.tradeTerms')" width="100"></el-table-column>
        <el-table-column prop="paymentMethod" align="center" :label="$t('rongzisqs.paymentMethod')" width="100"></el-table-column>
      </el-table>
      <el-pagination class="page-theme text-center pb_25" background layout="prev, pager, next"
                     :total="orderPage.total" :page-size="pageSize"
                     :current-page.sync="orderPage.pageNo" v-show="orderPage.total>5">
      </el-pagination>
    </z-collapse>
<!--    最近10笔订单 -->


  </div>
</template>

<script>
  import ZCollapse from "../ZCollapse";
  import mixins from '@/helper/mixins.js';
  export default {
    name: "baseInfoFinance",
    mixins: [mixins],
    components: {
      ZCollapse,
    },
    data(){
      return {
        pageSize:5,
        orderList:[], // 最近10笔订单 数据
        orderPage: {
          pageNo: 1,
          total: 0
        },
        financeList:[], //最近10笔融资申请
        financePage: {
          pageNo: 1,
          total: 0
        },
        dataObj:'',
      }
    },
    methods: {
      handleInit(data){
        this.dataObj = data;
        this.financeList = this.dataObj.recentTenZmaFmOrderVoList ? this.dataObj.recentTenZmaFmOrderVoList : [];
        this.financePage.total = this.dataObj.recentTenZmaFmOrderVoList.length;
        this.orderList = this.dataObj.recentTenCicOrderVoList ? this.dataObj.recentTenCicOrderVoList :[];
        this.orderPage.total = this.dataObj.recentTenCicOrderVoList.length;
      }
    },
    mounted() {
    }
  }
</script>

<style lang="scss" scoped>
  .cur-lending{
    font-weight: bold;
    font-size: 14px;
    line-height: 20px;
    padding: 20px 0;
  }
</style>
